import { IconButton, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/material";
import { ContainerForGrid, exploreTracksStyles } from "./styles";
import { Collaborators } from "../TracksPageComponents/Collaborators";
import { ShareModal } from "../Modal/ShareModal";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import { Collaborator } from "../../proto/api_pb";
import { handleCreateGroupChat } from "../TrackComponents/TrackHandler/trackHandlers";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { TalkJsContext, TalkJsContextInterface } from "../../contexts";
import { ExploreTrackCardProps } from "./types";
import { THEME } from "../../theme";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import { useAuth0 } from "@auth0/auth0-react";

export const ExploreTrackCard: React.FC<ExploreTrackCardProps> = ({
  tracks,
  title,
  setTrackToPlay,
  trackToPlay,
  setIsPlayButtonClicked,
  session,
  setInbox,
  loading,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const createGroupChat = (
    id: string | undefined,
    title: string | undefined,
    contributors: Collaborator[] | undefined
  ) => {
    handleCreateGroupChat(
      talkJsContext,
      contributors,
      navigate,
      undefined,
      id,
      title
    );
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography sx={exploreTracksStyles.titleTypography} variant="h5">
          {title}
        </Typography>
        <ContainerForGrid>
          {tracks && tracks.length > 0
            ? tracks.map((track, i) => (
                <Box key={i} sx={exploreTracksStyles.cardContainer}>
                  <div style={exploreTracksStyles.containerStyles}>
                    <img
                      style={exploreTracksStyles.img}
                      src={
                        track.getTrack()?.getImageUrl().includes("http")
                          ? track.getTrack()?.getImageUrl()
                          : "/assets/images/logo512.png"
                      }
                      alt={`${i}`}
                    />
                    <div style={exploreTracksStyles.collaboratorsStyles}>
                      <ShareModal
                        id={track.getTrack()?.getId() ?? ""}
                        isTrack={true}
                        title={track.getTrack()?.getTitle() ?? ""}
                      />
                    </div>
                  </div>

                  <Box sx={exploreTracksStyles.buttonContainer}>
                    <IconButton
                      sx={exploreTracksStyles.playButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsPlayButtonClicked(true);
                        setTrackToPlay((prev) => {
                          const isPlaying = prev?.isPlaying
                            ? !prev.isPlaying
                            : true;
                          return {
                            track: track.getTrack(),
                            url: track.getTrackVersion()?.getTrackUrl(),
                            isPlaying:
                              trackToPlay?.track?.getId() ===
                              track.getTrack()?.getId()
                                ? isPlaying
                                : true,
                          };
                        });
                      }}
                    >
                      {trackToPlay?.isPlaying &&
                      trackToPlay?.track?.getId() ===
                        track.getTrack()?.getId() ? (
                        <PauseCircleOutlineRoundedIcon
                          sx={{ fontSize: "50px" }}
                        />
                      ) : (
                        <PlayCircleOutlineRoundedIcon
                          sx={{ fontSize: "50px" }}
                        />
                      )}
                    </IconButton>
                  </Box>
                  <Box sx={exploreTracksStyles.bottomContainer}>
                    <Box sx={exploreTracksStyles.titleBox}>
                      <Typography sx={exploreTracksStyles.title}>
                        {track.getTrack()?.getTitle()}
                      </Typography>
                      <Typography sx={exploreTracksStyles.title}>
                        {track.getTrack()?.getSongMetadata()?.getGenre()}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Collaborators
                        collaborators={
                          track.getTrack()?.getCollaboratorsList() ?? []
                        }
                        isGridView={true}
                      />
                      {isAuthenticated && (
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            const trackId = track.getTrack()?.getId();
                            const trackTitle = track.getTrack()?.getTitle();
                            const contributors = track
                              .getTrack()
                              ?.getCollaboratorsList();
                            if (trackId && trackTitle && session) {
                              const talkInbox = session.createInbox();
                              setInbox(talkInbox);
                              talkJsContext.setIsChatOpen(true);
                              createGroupChat(
                                trackId,
                                trackTitle,
                                contributors
                              );
                            }
                            if (isSmallScreen) navigate("/messages");
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title="Chat with the artists"
                          >
                            <img
                              style={{
                                filter:
                                  THEME === "light"
                                    ? "invert(100%)"
                                    : "invert(0%)",
                              }}
                              src="/assets/icons/TracksPageIcons/message-chat-circle.svg"
                              alt="icon"
                            />
                          </Tooltip>
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Box>
              ))
            : null}
        </ContainerForGrid>
        {tracks.length === 0 && !loading && (
          <Typography>No tracks found!</Typography>
        )}
      </Box>
    </>
  );
};
